import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { AdminSidebar } from "@/components/sidebars";
import { apiClient, API } from "@/lib/api";
import { toast } from "sonner";

const money = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const TABS = [
  { id: "resumen", label: "Resumen", icon: "fa-chart-pie" },
  { id: "clientes", label: "Clientes", icon: "fa-users" },
  { id: "mensajes", label: "Mensajes", icon: "fa-paper-plane" },
  { id: "vendedores", label: "Vendedores", icon: "fa-user-tag" },
  { id: "config", label: "Dispersión", icon: "fa-sliders" },
  { id: "pixeles", label: "Píxeles", icon: "fa-bullseye" },
  { id: "export", label: "Exportar", icon: "fa-file-csv" },
];

export default function CRM() {
  const [tab, setTab] = useState("resumen");
  return (
    <AppLayout sidebar={AdminSidebar}>
      <header className="app-header"><h1>CRM & Conversión</h1><p className="text-muted">Adquisición, ventas, dispersión y comisiones</p></header>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 20 }}>
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`crm-tab-${t.id}`}
            className="btn" style={{ background: tab === t.id ? "#163680" : "#eef2f7", color: tab === t.id ? "white" : "#334155" }}>
            <i className={`fas ${t.icon}`} /> {t.label}
          </button>
        ))}
      </div>
      {tab === "resumen" && <Resumen />}
      {tab === "clientes" && <Clientes />}
      {tab === "mensajes" && <Mensajes />}
      {tab === "vendedores" && <Vendedores />}
      {tab === "config" && <Config />}
      {tab === "pixeles" && <Pixeles />}
      {tab === "export" && <Exportar />}
    </AppLayout>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="panel" style={{ padding: 16, minWidth: 150 }}>
      <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: 24, fontWeight: 800, color: color || "#163680" }} data-testid={`stat-${label}`}>{value}</div>
    </div>
  );
}

function Resumen() {
  const [d, setD] = useState(null);
  const [f, setF] = useState({ desde: "", hasta: "", canal: "", campana: "", ref: "" });
  const load = () => {
    const p = new URLSearchParams(Object.entries(f).filter(([, v]) => v));
    apiClient.get(`/funnel/dashboard?${p}`).then(({ data }) => setD(data)).catch(() => toast.error("Error al cargar métricas"));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  if (!d) return <div className="panel">Cargando…</div>;
  return (
    <div style={{ display: "grid", gap: 16 }}>
      <div className="panel" style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "end" }}>
        <div><label style={{ fontSize: 12 }}>Desde</label><input type="date" value={f.desde} onChange={(e) => setF({ ...f, desde: e.target.value })} data-testid="flt-desde" style={inp} /></div>
        <div><label style={{ fontSize: 12 }}>Hasta</label><input type="date" value={f.hasta} onChange={(e) => setF({ ...f, hasta: e.target.value })} data-testid="flt-hasta" style={inp} /></div>
        <div><label style={{ fontSize: 12 }}>Canal</label><input placeholder="tiktok, instagram…" value={f.canal} onChange={(e) => setF({ ...f, canal: e.target.value })} data-testid="flt-canal" style={inp} /></div>
        <div><label style={{ fontSize: 12 }}>Campaña</label><input value={f.campana} onChange={(e) => setF({ ...f, campana: e.target.value })} style={inp} /></div>
        <div><label style={{ fontSize: 12 }}>Ref</label><input value={f.ref} onChange={(e) => setF({ ...f, ref: e.target.value })} style={inp} /></div>
        <button className="btn btn-primary" onClick={load} data-testid="flt-aplicar">Aplicar</button>
      </div>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <Stat label="Visitas" value={d.visitas} />
        <Stat label="Leads" value={d.leads} />
        <Stat label="Pagos iniciados" value={d.pagos_iniciados} />
        <Stat label="Pagos aprobados" value={d.pagos_aprobados} color="#5BA628" />
        <Stat label="Conv. Visita→Lead" value={`${d.conv_visita_lead}%`} />
        <Stat label="Conv. Lead→Pago" value={`${d.conv_lead_pago}%`} />
      </div>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <Stat label="Clientes activos" value={d.clientes_activos} color="#5BA628" />
        <Stat label="Vencidos" value={d.clientes_vencidos} color="#E84C5E" />
        <Stat label="Cancelados" value={d.clientes_cancelados} color="#E84C5E" />
      </div>

      <div className="panel">
        <h3 style={{ marginTop: 0 }}>Finanzas (dispersión)</h3>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Stat label="Ingreso bruto" value={money(d.ingreso_bruto)} />
          <Stat label="Costo proveedor" value={money(d.costo_proveedor)} color="#E84C5E" />
          <Stat label="Comisiones" value={money(d.comisiones)} color="#E84C5E" />
          <Stat label="Impuestos" value={money(d.impuestos)} color="#E84C5E" />
          <Stat label="Reserva contracargos" value={money(d.reserva_contracargos)} color="#b45309" />
          <Stat label="Utilidad neta" value={money(d.utilidad_neta)} color="#5BA628" />
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 16 }}>
        <GroupTable title="Ventas por canal" rows={d.por_canal} />
        <GroupTable title="Ventas por campaña" rows={d.por_campana} />
        <GroupTable title="Ventas por anuncio" rows={d.por_anuncio} />
        <GroupTable title="Ventas por referido" rows={d.por_referido} />
      </div>
    </div>
  );
}

function GroupTable({ title, rows }) {
  return (
    <div className="panel">
      <h4 style={{ marginTop: 0 }}>{title}</h4>
      {(!rows || !rows.length) && <p className="text-muted">Sin datos aún.</p>}
      {rows && rows.map((r, i) => (
        <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #f1f5f9", fontSize: 14 }}>
          <span>{r.nombre}</span><span><strong>{r.ventas}</strong> · {money(r.monto)}</span>
        </div>
      ))}
    </div>
  );
}

function Clientes() {
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState(null);
  const [detail, setDetail] = useState(null);
  useEffect(() => { apiClient.get("/funnel/clients").then(({ data }) => setRows(data)).catch(() => {}); }, []);
  const open = (id) => { setSel(id); apiClient.get(`/funnel/client/${id}`).then(({ data }) => setDetail(data)); };
  return (
    <div className="panel">
      <h3 style={{ marginTop: 0 }}>Clientes ({rows.length})</h3>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }} data-testid="clientes-table">
          <thead><tr style={{ textAlign: "left", color: "#6b7280" }}><th style={th}>Nombre</th><th style={th}>Celular</th><th style={th}>Ciudad</th><th style={th}>Origen</th><th style={th}>Estatus</th><th style={th}></th></tr></thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id} style={{ borderTop: "1px solid #f1f5f9" }}>
                <td style={td}>{c.nombre}</td><td style={td}>{c.celular}</td><td style={td}>{c.ciudad}</td>
                <td style={td}>{c.origen || "directo"}</td>
                <td style={td}><span style={{ fontSize: 12, fontWeight: 700, color: c.estatus === "active" ? "#5BA628" : "#E84C5E" }}>{c.estatus}</span></td>
                <td style={td}><button className="btn" onClick={() => open(c.id)} data-testid={`ver-cliente-${c.id}`}>Ver</button></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} style={td}>Sin clientes aún.</td></tr>}
          </tbody>
        </table>
      </div>
      {sel && detail && (
        <div onClick={() => setSel(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "flex-start", padding: 20, zIndex: 50, overflowY: "auto" }}>
          <div onClick={(e) => e.stopPropagation()} className="panel" style={{ maxWidth: 620, width: "100%", marginTop: 40 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ marginTop: 0 }}>{detail.cliente.nombre}</h3><button className="btn" onClick={() => setSel(null)}>✕</button></div>
            <p className="text-muted" style={{ marginTop: -6 }}>{detail.cliente.email} · {detail.cliente.celular} · {detail.cliente.ciudad}, {detail.cliente.estado}</p>
            <p style={{ fontSize: 13 }}>Origen: <strong>{detail.cliente.origen || "directo"}</strong> · Campaña: {detail.cliente.campana || "—"} · Ref: {detail.cliente.referido || "—"}</p>
            <h4>Membresías</h4>
            {detail.membresias.map((m) => <div key={m.id} style={{ fontSize: 14 }}>Folio <strong>{m.folio}</strong> · {m.estatus} · vence {m.fecha_vencimiento?.slice(0, 10)}</div>)}
            <h4>Pagos</h4>
            {detail.pagos.map((p) => <div key={p.id} style={{ fontSize: 14 }}>{money(p.monto_bruto)} · {p.estatus} · {p.fecha_aprobacion?.slice(0, 10) || p.fecha_intento?.slice(0, 10)}</div>)}
            <h4>Beneficiarios</h4>
            {detail.beneficiarios.length ? detail.beneficiarios.map((b) => <div key={b.id} style={{ fontSize: 14 }}>{b.nombre} — {b.parentesco}</div>) : <p className="text-muted">Ninguno</p>}
            <h4>Mensajes enviados</h4>
            {detail.mensajes && detail.mensajes.length ? detail.mensajes.map((m) => (
              <div key={m.id} style={{ fontSize: 13 }}>
                <i className={`fa${CH[m.channel]?.fab ? "b" : "s"} ${CH[m.channel]?.icon || "fa-comment"}`} style={{ color: CH[m.channel]?.color || "#64748b", marginRight: 6, width: 16 }} />
                {m.kind} · <span style={{ color: stColor(m.status) }}>{stLabel(m.status)}</span> · {m.created_at?.slice(0, 16).replace("T", " ")}
              </div>
            )) : <p className="text-muted">Sin mensajes aún.</p>}
          </div>
        </div>
      )}
    </div>
  );
}

const KINDS = { welcome: "Bienvenida", recovery_1: "Recuperación 1 (15 min)", recovery_2: "Recuperación 2 (24 h)", recovery_3: "Recuperación 3 (72 h)", renewal_reminder: "Recordatorio renovación", winback: "Reactivación (win-back)" };
const CH = {
  email: { label: "Email", icon: "fa-envelope", color: "#2563eb", fab: false },
  whatsapp: { label: "WhatsApp", icon: "fa-whatsapp", color: "#25D366", fab: true },
  sms: { label: "SMS", icon: "fa-comment-sms", color: "#7c3aed", fab: false },
};
const stColor = (s) => s === "sent" ? "#5BA628" : (s || "").startsWith("skipped") ? "#94a3b8" : "#E84C5E";
const stLabel = (s) => ({ sent: "Enviado", error: "Error", skipped_no_creds: "Sin configurar", skipped_no_email: "Sin email", skipped_no_phone: "Sin celular" }[s] || s);

function Mensajes() {
  const [data, setData] = useState(null);
  const [f, setF] = useState({ channel: "", kind: "", status: "" });
  const load = () => {
    const p = new URLSearchParams(Object.entries(f).filter(([, v]) => v));
    apiClient.get(`/funnel/messages?${p}`).then(({ data }) => setData(data)).catch(() => toast.error("Error al cargar mensajes"));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  if (!data) return <div className="panel">Cargando…</div>;
  const sm = data.summary || {};
  const sent = (ch) => (sm[ch]?.sent || 0);
  const errd = (ch) => Object.entries(sm[ch] || {}).filter(([k]) => k === "error").reduce((a, [, v]) => a + v, 0);
  return (
    <div style={{ display: "grid", gap: 16 }}>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        {["email", "whatsapp", "sms"].map((ch) => (
          <div key={ch} className="panel" style={{ padding: 16, minWidth: 180 }} data-testid={`msg-summary-${ch}`}>
            <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 600 }}>
              <i className={`fa${CH[ch].fab ? "b" : "s"} ${CH[ch].icon}`} style={{ color: CH[ch].color, marginRight: 6 }} />{CH[ch].label}
            </div>
            <div style={{ fontSize: 24, fontWeight: 800, color: CH[ch].color }}>{sent(ch)} <span style={{ fontSize: 13, fontWeight: 600, color: "#94a3b8" }}>enviados</span></div>
            {errd(ch) > 0 && <div style={{ fontSize: 12, color: "#E84C5E", fontWeight: 700 }}>{errd(ch)} con error</div>}
          </div>
        ))}
      </div>

      <div className="panel">
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "end", marginBottom: 14 }}>
          <div><label style={{ fontSize: 12 }}>Canal</label>
            <select style={inp} value={f.channel} onChange={(e) => setF({ ...f, channel: e.target.value })} data-testid="msg-flt-canal">
              <option value="">Todos</option><option value="email">Email</option><option value="whatsapp">WhatsApp</option><option value="sms">SMS</option>
            </select></div>
          <div><label style={{ fontSize: 12 }}>Tipo</label>
            <select style={inp} value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} data-testid="msg-flt-tipo">
              <option value="">Todos</option>{Object.entries(KINDS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select></div>
          <div><label style={{ fontSize: 12 }}>Estado</label>
            <select style={inp} value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} data-testid="msg-flt-estado">
              <option value="">Todos</option><option value="sent">Enviado</option><option value="error">Error</option><option value="skipped_no_creds">Sin configurar</option>
            </select></div>
          <button className="btn btn-primary" onClick={load} data-testid="msg-flt-aplicar">Aplicar</button>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }} data-testid="mensajes-table">
            <thead><tr style={{ textAlign: "left", color: "#6b7280" }}><th style={th}>Canal</th><th style={th}>Tipo</th><th style={th}>Destino</th><th style={th}>Estado</th><th style={th}>Fecha</th></tr></thead>
            <tbody>
              {data.rows.map((m) => (
                <tr key={m.id} style={{ borderTop: "1px solid #f1f5f9" }}>
                  <td style={td}><i className={`fa${CH[m.channel]?.fab ? "b" : "s"} ${CH[m.channel]?.icon || "fa-comment"}`} style={{ color: CH[m.channel]?.color || "#64748b", marginRight: 6 }} />{CH[m.channel]?.label || m.channel}</td>
                  <td style={td}>{KINDS[m.kind] || m.kind}</td>
                  <td style={td}>{m.to || m.phone || "—"}</td>
                  <td style={td}><span style={{ fontSize: 12, fontWeight: 700, color: stColor(m.status) }}>{stLabel(m.status)}</span></td>
                  <td style={td}>{m.created_at?.slice(0, 16).replace("T", " ")}</td>
                </tr>
              ))}
              {!data.rows.length && <tr><td colSpan={5} style={td}>Sin mensajes aún.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function Vendedores() {
  const [rows, setRows] = useState([]);
  const [comm, setComm] = useState([]);
  const [nv, setNv] = useState({ nombre: "", tipo: "vendedor", codigo: "", commission_type: "fixed", commission_value: 5 });
  const load = () => {
    apiClient.get("/funnel/referrers").then(({ data }) => setRows(data)).catch(() => {});
    apiClient.get("/funnel/commissions").then(({ data }) => setComm(data)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  const create = async () => {
    if (!nv.nombre || !nv.codigo) { toast.error("Nombre y código requeridos"); return; }
    try { await apiClient.post("/funnel/referrers", { ...nv, commission_value: Number(nv.commission_value) }); toast.success("Creado"); setNv({ nombre: "", tipo: "vendedor", codigo: "", commission_type: "fixed", commission_value: 5 }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const [payFor, setPayFor] = useState(null); // referrer being paid
  const [payForm, setPayForm] = useState({ monto: "", metodo: "transferencia", referencia: "" });
  const openPay = (c) => {
    const r = rows.find((x) => x.codigo === c.codigo);
    if (!r) { toast.error("Socio no encontrado"); return; }
    setPayFor({ ...r, saldo: c.saldo_pendiente });
    setPayForm({ monto: String(c.saldo_pendiente || ""), metodo: "transferencia", referencia: "" });
  };
  const submitPay = async () => {
    const monto = Number(payForm.monto);
    if (!monto || monto <= 0) { toast.error("Ingresa un monto válido"); return; }
    try {
      await apiClient.post(`/funnel/referrers/${payFor.id}/payout`, { ...payForm, monto });
      toast.success(`Pago de ${money(monto)} registrado`);
      setPayFor(null); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error al registrar pago"); }
  };
  return (
    <div style={{ display: "grid", gap: 16 }}>
      <div className="panel">
        <h3 style={{ marginTop: 0 }}>Nuevo vendedor / afiliado / influencer</h3>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "end" }}>
          <div><label style={{ fontSize: 12 }}>Nombre</label><input style={inp} value={nv.nombre} onChange={(e) => setNv({ ...nv, nombre: e.target.value })} data-testid="ref-nombre" /></div>
          <div><label style={{ fontSize: 12 }}>Tipo</label><select style={inp} value={nv.tipo} onChange={(e) => setNv({ ...nv, tipo: e.target.value })} data-testid="ref-tipo"><option value="vendedor">Vendedor</option><option value="afiliado">Afiliado</option><option value="influencer">Influencer</option></select></div>
          <div><label style={{ fontSize: 12 }}>Código</label><input style={inp} value={nv.codigo} onChange={(e) => setNv({ ...nv, codigo: e.target.value.toUpperCase() })} data-testid="ref-codigo" placeholder="JUANPEREZ" /></div>
          <div><label style={{ fontSize: 12 }}>Comisión</label><select style={inp} value={nv.commission_type} onChange={(e) => setNv({ ...nv, commission_type: e.target.value })}><option value="fixed">$ fija</option><option value="percent">% </option></select></div>
          <div><label style={{ fontSize: 12 }}>Valor</label><input style={{ ...inp, width: 80 }} type="number" value={nv.commission_value} onChange={(e) => setNv({ ...nv, commission_value: e.target.value })} /></div>
          <button className="btn btn-primary" onClick={create} data-testid="ref-crear">Crear</button>
        </div>
      </div>
      <div className="panel">
        <h3 style={{ marginTop: 0 }}>Comisiones</h3>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }} data-testid="comisiones-table">
            <thead><tr style={{ textAlign: "left", color: "#6b7280" }}><th style={th}>Nombre</th><th style={th}>Tipo</th><th style={th}>Código</th><th style={th}>Leads</th><th style={th}>Ventas</th><th style={th}>Generada</th><th style={th}>Pendiente</th><th style={th}>Acciones</th></tr></thead>
            <tbody>
              {comm.map((c, i) => {
                const r = rows.find((x) => x.codigo === c.codigo);
                return (
                  <tr key={i} style={{ borderTop: "1px solid #f1f5f9" }}>
                    <td style={td}>{c.nombre}</td><td style={td}>{c.tipo}</td><td style={td}><strong>{c.codigo}</strong></td>
                    <td style={td}>{c.leads}</td><td style={td}>{c.ventas}</td><td style={td}>{money(c.comision_generada)}</td><td style={td}><strong style={{ color: c.saldo_pendiente > 0 ? "#b45309" : "#64748b" }}>{money(c.saldo_pendiente)}</strong></td>
                    <td style={td}>
                      <button className="btn" onClick={() => { navigator.clipboard?.writeText(window.location.origin + "/" + (r?.link || "")); toast.success("Link copiado"); }} data-testid={`ref-copy-${c.codigo}`}>Copiar link</button>{" "}
                      <button className="btn btn-primary" disabled={!(c.saldo_pendiente > 0)} onClick={() => openPay(c)} data-testid={`ref-pagar-${c.codigo}`}>Pagar</button>
                    </td>
                  </tr>
                );
              })}
              {!comm.length && <tr><td colSpan={8} style={td}>Aún no hay vendedores.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
      {payFor && (
        <div onClick={() => setPayFor(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", padding: 20, zIndex: 50 }}>
          <div onClick={(e) => e.stopPropagation()} className="panel" style={{ maxWidth: 420, width: "100%" }} data-testid="payout-modal">
            <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ marginTop: 0 }}>Pagar comisión</h3><button className="btn" onClick={() => setPayFor(null)}>✕</button></div>
            <p className="text-muted" style={{ marginTop: -6 }}>{payFor.nombre} · {payFor.codigo} · Saldo: <strong style={{ color: "#b45309" }}>{money(payFor.saldo)}</strong></p>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Monto a pagar</label>
            <input style={{ ...inp, width: "100%", marginBottom: 10 }} type="number" step="0.01" value={payForm.monto} onChange={(e) => setPayForm({ ...payForm, monto: e.target.value })} data-testid="payout-monto" />
            <label style={{ fontSize: 12, fontWeight: 600 }}>Método</label>
            <select style={{ ...inp, width: "100%", marginBottom: 10 }} value={payForm.metodo} onChange={(e) => setPayForm({ ...payForm, metodo: e.target.value })} data-testid="payout-metodo">
              <option value="transferencia">Transferencia</option><option value="efectivo">Efectivo</option><option value="otro">Otro</option>
            </select>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Referencia (opcional)</label>
            <input style={{ ...inp, width: "100%", marginBottom: 14 }} value={payForm.referencia} onChange={(e) => setPayForm({ ...payForm, referencia: e.target.value })} placeholder="No. de operación" data-testid="payout-referencia" />
            <button className="btn btn-primary" style={{ width: "100%" }} onClick={submitPay} data-testid="payout-submit">Registrar pago</button>
          </div>
        </div>
      )}
    </div>
  );
}

function Config() {
  const [s, setS] = useState(null);
  useEffect(() => { apiClient.get("/funnel/settings").then(({ data }) => setS(data)).catch(() => {}); }, []);
  const save = async () => {
    try { await apiClient.put("/funnel/settings", s); toast.success("Configuración guardada"); }
    catch { toast.error("Error al guardar"); }
  };
  if (!s) return <div className="panel">Cargando…</div>;
  const fields = [
    ["price", "Precio de venta"], ["provider_cost", "Costo proveedor"],
    ["seller_commission", "Comisión vendedor"], ["affiliate_commission", "Comisión afiliado"],
    ["influencer_commission", "Comisión influencer"], ["chargeback_reserve", "Reserva contracargos"],
    ["tax_pct", "IVA (0.16 = 16%)"], ["gateway_pct", "Comisión pasarela % (0.036)"],
    ["gateway_fixed", "Comisión pasarela fija"], ["membership_days", "Días de vigencia"],
    ["upsell_annual_price", "Upsell Anual 1-clic (precio 30% off)"],
  ];
  const preview = () => {
    const g = Number(s.price);
    const gw = g * Number(s.gateway_pct) + Number(s.gateway_fixed);
    const tax = g * Number(s.tax_pct);
    const net = g - gw - tax - Number(s.provider_cost) - Number(s.seller_commission) - Number(s.chargeback_reserve);
    return net;
  };
  return (
    <div className="panel" style={{ maxWidth: 640 }}>
      <h3 style={{ marginTop: 0 }}>Reglas de dispersión financiera</h3>
      <p className="text-muted">Edita sin tocar código. Aplica a las próximas ventas.</p>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {fields.map(([k, label]) => (
          <div key={k}><label style={{ fontSize: 12, fontWeight: 600 }}>{label}</label>
            <input style={inp} type="number" step="0.01" value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`cfg-${k}`} />
          </div>
        ))}
      </div>
      <div style={{ marginTop: 14, padding: 12, background: "#F3F7FF", borderRadius: 10 }}>
        Utilidad neta estimada por venta (con comisión de vendedor): <strong style={{ color: "#5BA628" }}>{money(preview())}</strong>
      </div>
      <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12, fontSize: 14, cursor: "pointer" }}>
        <input type="checkbox" checked={!!s.upsell_enabled}
          onChange={(e) => setS({ ...s, upsell_enabled: e.target.checked })} data-testid="cfg-upsell-enabled" />
        Ofrecer upsell 1-clic a Anual (30% off) en la página de gracias
      </label>
      <button className="btn btn-primary" onClick={save} data-testid="cfg-guardar" style={{ marginTop: 14 }}>Guardar configuración</button>
    </div>
  );
}

function Pixeles() {
  const [p, setP] = useState(null);
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    apiClient.get("/funnel/pixels").then(({ data }) => setP(data)).catch(() => {});
    apiClient.get("/funnel/pixels/logs").then(({ data }) => setLogs(data || [])).catch(() => {});
  }, []);
  const save = async () => {
    try {
      const { data } = await apiClient.put("/funnel/pixels", p);
      setP(data);
      toast.success("Píxeles guardados — ya se disparan en lead, checkout y compra");
    } catch { toast.error("Error al guardar"); }
  };
  if (!p) return <div className="panel">Cargando…</div>;
  const groups = [
    ["Meta (Facebook / Instagram)", "fab fa-facebook", [
      ["meta_pixel_id", "Pixel ID"], ["meta_capi_token", "Token Conversions API"], ["meta_test_code", "Test Event Code (opcional)"],
    ]],
    ["TikTok", "fab fa-tiktok", [
      ["tiktok_pixel_id", "Pixel ID"], ["tiktok_token", "Access Token (Events API)"],
    ]],
    ["Google Analytics 4 — server-side", "fab fa-google", [
      ["ga4_measurement_id", "Measurement ID (G-XXXX)"], ["ga4_api_secret", "API Secret (Measurement Protocol)"],
    ]],
  ];
  return (
    <div className="panel" style={{ maxWidth: 760 }} data-testid="pixels-panel">
      <h3 style={{ marginTop: 0 }}>Píxeles de conversión + CAPI server-side</h3>
      <p className="text-muted">Pega tus IDs y tokens. Los eventos <strong>Lead → InitiateCheckout → Purchase</strong> se envían desde el navegador Y desde el servidor (deduplicados por event_id) para optimizar tus campañas.</p>
      {groups.map(([title, icon, fields]) => (
        <div key={title} style={{ marginBottom: 18 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}><i className={icon} /> {title}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {fields.map(([k, label]) => (
              <div key={k}><label style={{ fontSize: 12, fontWeight: 600 }}>{label}</label>
                <input style={{ ...inp, width: "100%", boxSizing: "border-box" }} value={p[k] || ""}
                  onChange={(e) => setP({ ...p, [k]: e.target.value })} data-testid={`px-${k}`} />
              </div>
            ))}
          </div>
        </div>
      ))}
      <button className="btn btn-primary" onClick={save} data-testid="px-guardar">Guardar píxeles</button>
      <h4 style={{ marginTop: 24, marginBottom: 8 }}>Últimos eventos server-side</h4>
      {logs.length === 0 ? (
        <p className="text-muted" data-testid="px-logs-empty">Aún no se envían eventos (configura al menos una plataforma y genera una venta o lead).</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }} data-testid="px-logs">
          <thead><tr style={{ textAlign: "left", background: "#f1f5f9" }}>
            <th style={th}>Fecha</th><th style={th}>Plataforma</th><th style={th}>Evento</th><th style={th}>OK</th>
          </tr></thead>
          <tbody>{logs.slice(0, 20).map((l) => (
            <tr key={l.id} style={{ borderTop: "1px solid #e2e8f0" }}>
              <td style={td}>{(l.created_at || "").slice(0, 19).replace("T", " ")}</td>
              <td style={td}>{l.platform}</td><td style={td}>{l.event}</td>
              <td style={td}>{l.ok ? "✅" : "❌"}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </div>
  );
}

function Exportar() {
  const kinds = [
    ["clientes_activos", "Clientes activos"], ["clientes_vencidos", "Clientes vencidos"],
    ["clientes_cancelados", "Clientes cancelados"], ["pagos_aprobados", "Pagos aprobados"],
    ["pagos_rechazados", "Pagos rechazados"], ["dispersion", "Dispersión financiera"],
    ["comisiones", "Comisiones"],
  ];
  const dl = async (kind) => {
    try {
      const res = await apiClient.get(`/funnel/export/${kind}`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a"); a.href = url; a.download = `${kind}.csv`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Error al exportar"); }
  };
  return (
    <div className="panel">
      <h3 style={{ marginTop: 0 }}>Exportar a CSV</h3>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {kinds.map(([k, l]) => <button key={k} className="btn btn-primary" onClick={() => dl(k)} data-testid={`export-${k}`}><i className="fas fa-download" /> {l}</button>)}
      </div>
    </div>
  );
}

const inp = { padding: "9px 11px", borderRadius: 8, border: "1px solid #cbd5e1", fontSize: 14, fontFamily: "inherit" };
const th = { padding: "8px 10px", fontWeight: 600, fontSize: 12 };
const td = { padding: "8px 10px" };
